import React from "react";
import { motion } from "framer-motion";

const Contact = ({ details }) => {
  return (
    <section id="contact">
      <div className="container mt-5 mb-5">
        <div className="d-flex flex-column section-header">
          <h2 className="pt-3 pb-3 fw-bold">We Are Available</h2>
          <h5 className="fw-medium pb-3">Get In Touch</h5>
        </div>
        <div className="my-5">
          <div className="row">
            {details.map((item, index) => (
              <motion.div
                initial={{ opacity: 0, x: -50 }} // Start with opacity 0 and off to the left (x: -50)
                whileInView={{ opacity: 1, x: 0 }} // Fade in and move to its normal position (x: 0)
                transition={{ duration: 0.6, delay: index * 0.3 }} // Delay each item by 0.3s
                viewport={{ once: true }} // Ensure it only runs once
                className="col-md-4 mb-3"
                key={index}
              >
                <div className="card contact-card">
                  <div className="card-body">
                    {item.icons && (
                      <div className="contact-icon">{item.icons}</div>
                    )}
                    <h4 className="card-title">{item.title}</h4>
                    <p className="texts">{item.text}</p>
                    <div>{item.href && <a href={item.href}>Open</a>}</div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
